import React, { useState, useEffect, useRef } from "react";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import InitialsCircle from "../../components/InitialsCircle";
import "./CustomTypeAhead.css";

const CustomTypeAhead = ({
  value = "",
  data = [],
  onSearch,
  onSelect,
  placeholder = "Search...",
  required = false,
  minLength = 3,
  labelKey = "label",
  isEmployeeSearch = false,
  valueLabelKey = "value",
  isError = false,
  onChange,
}) => {
  console.log("data in typeahead", data);

  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [error, setError] = useState("");
  const containerRef = useRef(null);

  const debounceRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;

    onChange && onChange(value);

    if (required && !value) {
      setError("This field is required");
      setShowDropdown(false);
      return;
    }

    if (value.length > 0 && value.length < minLength) {
      setError(`Minimum ${minLength} characters required`);
      setShowDropdown(false);
    } else {
      setError("");
    }

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (value.length >= minLength) {
      debounceRef.current = setTimeout(() => {
        onSearch(value);
        setShowDropdown(true);
      }, 500);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelect = (item) => {
    setInputValue(item[valueLabelKey] || item);
    setShowDropdown(false);
    onSelect(item);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const visibleData = Array.isArray(data) ? data.slice(0, 10) : [];

  return (
    <div
      className="flex flex-col form-detail"
      style={{ position: "relative" }}
      ref={containerRef}
    >
      <div className="emp-form-label">{labelKey}</div>

      <input
        type="text"
        className={`emp-form-input ${
          isError && required && !value ? "error-border" : ""
        }`}
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder}
      />

      {isError && required && !value && (
        <div className="valid-text flex items-center">
          <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
          <div>Select a valid {labelKey}</div>
        </div>
      )}

      {showDropdown && visibleData.length > 0 && (
        <ul className="ty-drop">
          {visibleData.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
              className="ty-drop-item"
            >
              {isEmployeeSearch ? (
                <>
                  <div className="flex items-center">
                    <InitialsCircle fullName={item[valueLabelKey]} size={24} />
                    <div className="ty-drop-item-text ml-2">
                      {item?.full_name}
                    </div>
                    <div className="ty-drop-item-text grey">
                      &nbsp;&nbsp;&nbsp;#{item?.employee_id}
                    </div>
                  </div>
                  <div className="ty-drop-item-text">{item?.designation}</div>
                </>
              ) : (
                <div className="ty-drop-item-text">{item[valueLabelKey]}</div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomTypeAhead;
